// src/areaAssociados/ModalAviso.js
import React from 'react';
import { FaClock, FaCalendar, FaBullhorn, FaFilePdf, FaImage } from 'react-icons/fa';

const CoresTipo = {
  aviso: { bg: '#e3f2fd', border: '#1976d2', text: '#1976d2' },
  alerta: { bg: '#fff3e0', border: '#f57c00', text: '#f57c00' },
  urgente: { bg: '#ffebee', border: '#d32f2f', text: '#d32f2f' },
  evento: { bg: '#e8f5e9', border: '#388e3c', text: '#388e3c' },
  info: { bg: '#e3f2fd', border: '#1976d2', text: '#1976d2' }
};

const ModalAviso = ({ aviso, onClose }) => {
  if (!aviso) return null;

  const cores = CoresTipo[aviso.tipo] || CoresTipo.aviso;

  const formatarData = (data) => {
    if (!data) return '';
    const d = new Date(data);
    return d.toLocaleDateString('pt-BR', { 
      day: '2-digit', 
      month: 'long', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <button style={styles.fechar} onClick={onClose}>×</button>
        
        {aviso.imagemUrl && (
          <div style={styles.imagem}>
            <img 
              src={aviso.imagemUrl} 
              alt={aviso.titulo}
              style={{ ...styles.img, cursor: 'pointer' }}
              onClick={() => window.open(aviso.imagemUrl, '_blank')}
              onError={(e) => e.target.style.display = 'none'}
            />
            <button
              onClick={() => window.open(aviso.imagemUrl, '_blank')}
              style={styles.verImagemBtn}
            >
              <FaImage size={14} /> Ver imagem completa
            </button>
          </div>
        )}
        
        <div style={styles.conteudo}>
          <div style={styles.header}>
            <span style={{
              ...styles.tipoBadge,
              backgroundColor: cores.bg,
              color: cores.text,
              border: `1px solid ${cores.border}`
            }}>
              {aviso.tipoLabel}
            </span>
            {aviso.prioridade === 'alta' && (
              <span style={styles.prioridadeBadge}>⚡ priority</span>
            )}
          </div>
          
          <h2 style={{...styles.titulo, color: cores.text}}>{aviso.titulo}</h2>
          
          {aviso.mensagem && (
            <div style={{ ...styles.mensagem, whiteSpace: 'pre-line' }}>
              <p style={{ margin: 0, lineHeight: '1.7' }}>{aviso.mensagem}</p>
            </div>
          )}
          
          {aviso.pdfUrl && (
            <a 
              href={aviso.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: '12px',
                padding: '10px 16px',
                backgroundColor: '#ffebee',
                color: '#c62828',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '13px',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              <FaFilePdf size={16} /> Abrir documento PDF
            </a>
          )}
          
          <div style={styles.info}>
            <div style={styles.infoItem}>
              <FaClock size={14} color="#666" />
              <span>Publicado em: {formatarData(aviso.createdAt)}</span>
            </div>
            
            {aviso.eventoTitulo && (
              <div style={styles.infoItem}>
                <FaCalendar size={14} color="#388e3c" />
                <span>Evento: {aviso.eventoTitulo}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '20px'
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '450px',
    maxHeight: '90vh',
    overflow: 'auto',
    position: 'relative'
  },
  fechar: {
    position: 'absolute',
    top: '10px',
    right: '15px',
    background: 'rgba(0,0,0,0.5)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10
  },
  imagem: {
    width: '100%',
    height: '200px',
    overflow: 'hidden',
    position: 'relative'
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  verImagemBtn: {
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    padding: '6px 12px',
    backgroundColor: 'rgba(0,0,0,0.6)',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  conteudo: {
    padding: '20px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '12px'
  },
  tipoBadge: {
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    fontFamily: 'Montserrat, sans-serif'
  },
  prioridadeBadge: {
    fontSize: '12px',
    color: '#ff9800',
    fontWeight: '700',
    fontFamily: 'Montserrat, sans-serif'
  },
  titulo: {
    fontSize: '20px',
    fontWeight: '700',
    marginBottom: '15px',
    fontFamily: 'Montserrat, sans-serif',
    lineHeight: '1.3'
  },
  mensagem: {
    fontSize: '14px',
    color: '#333',
    fontFamily: 'Montserrat, sans-serif',
    lineHeight: '1.6',
    marginBottom: '15px'
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    paddingTop: '15px',
    borderTop: '1px solid #eee'
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    color: '#666',
    fontFamily: 'Montserrat, sans-serif'
  }
};

export default ModalAviso;